import { render } from "./SubstudyDetail.vue?vue&type=template&id=7b05575e&scoped=true"
import script from "./SubstudyDetail.vue?vue&type=script&lang=js"
export * from "./SubstudyDetail.vue?vue&type=script&lang=js"

import "./SubstudyDetail.vue?vue&type=style&index=0&id=7b05575e&scoped=true&lang=css"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b05575e"]])

export default __exports__